import SettingsAutomotives    from 'scripts/defa/settings-automotive/collection-settings-automotives';
import SettingsAutomotive     from 'scripts/defa/settings-automotive/model-settings-automotive';
import SettingsAutomotiveForm from 'scripts/defa/settings-automotive/view-settings-automotive-form';
import Module                 from 'scripts/module';

const SettingsAutomotiveModule = new Module( 'SettingsAutomotiveModule', {
	collections: {
		SettingsAutomotives
	},
	models     : {
		SettingsAutomotive
	},
	views      : {
		SettingsAutomotiveForm
	}
} );
export default SettingsAutomotiveModule;